import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Ads
 */
export default class AdsListValueObjectLegacy extends ValueObject {
  /**
   * @param {Object} deps
   * @param {Array<AdAggregationsListValueObject>} deps.aggregations
   * @param {Array<AdEntity>} deps.items
   * @param {AdEntity} deps.highlightedAd
   * @param {Number} deps.totalPages
   * @param {Number} deps.totalResults
   */

  getItems = () => this._items
}
